var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#febaba"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(533.119 -126.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M-488.562,255.523a20.324,20.324,0,0,1-8.659-2.16,46.647,46.647,0,0,1-13.859-10.485,41.179,41.179,0,0,1-8.207-12.125,22.182,22.182,0,0,1-1.832-8.628c-.018-4.768,4.851-9.272,9.4-8.912a4.5,4.5,0,0,1,4.26,3.2c.786,2.365,1.564,4.733,2.37,7.091a3.811,3.811,0,0,1-1.018,4.318c-.727.7-1.418,1.429-2.141,2.129a.45.45,0,0,0-.115.62,24.778,24.778,0,0,0,11.618,11.693.516.516,0,0,0,.717-.113c.558-.594,1.162-1.145,1.721-1.738a3.8,3.8,0,0,1,3.981-1.111c2.7.686,5.4,1.392,8.111,2.025a4.066,4.066,0,0,1,3.277,3.588,8.086,8.086,0,0,1-2.315,7.045,10.73,10.73,0,0,1-5.159,3.264A13.664,13.664,0,0,1-488.562,255.523Z",
    transform: "translate(0 -65.97)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M-299.938,166.428a8.715,8.715,0,0,1-.1,1.134,2.471,2.471,0,0,1-2.627,1.965,2.5,2.5,0,0,1-2.281-2.477,21.541,21.541,0,0,0-1.652-8.409,22.131,22.131,0,0,0-16.672-13.679,26.425,26.425,0,0,0-4.026-.406A2.576,2.576,0,0,1-329.946,142a2.527,2.527,0,0,1,2.681-2.451,27.5,27.5,0,0,1,26.673,21.773c.345,1.674.5,3.388.737,5.084Z",
    transform: "translate(-171.263)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M-310.037,252.609c.027,1.561-.575,2.535-1.692,2.907a2.5,2.5,0,0,1-3.288-2.426,12.115,12.115,0,0,0-2.342-7.194,12.285,12.285,0,0,0-10.081-5.241,2.531,2.531,0,0,1-2.552-2.145,2.42,2.42,0,0,1,1.615-2.662,5.037,5.037,0,0,1,1.741-.155A17.486,17.486,0,0,1-310.9,247.72,17.525,17.525,0,0,1-310.037,252.609Z",
    transform: "translate(-171.196 -86.114)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0ad848b485142a9997938efbb34ab831.svg";
export { ForwardRef as ReactComponent };